import { serverUrl } from "@globalConfig";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { getAndClearTrackingReferralParams } from "@hooks/useHashToLocalStoreEvent";
import { trackEvents } from "@/common/events/events";
import { isRangeFilter } from "@/pages/search/searchHooks/utils";
import { isAutosOrYearsScreen } from "@/pages/search/searchHooks/filtersHelpers";
import useLocalStorage from "@hooks/useLocalStorage";
import { handleFilter } from "@/apis/search/searchUtils";
export default function filterPageAnalytics(_ref) {
  var page = _ref.page,
    filters = _ref.filters,
    isBrowserBehaviour = _ref.isBrowserBehaviour,
    searchResults = _ref.searchResults,
    location = _ref.location;
  if (!searchResults.metaData) return;
  trackSearchEvents(page, filters, searchResults, location);
  if (isBrowserBehaviour) {
    unbxdAnalytics({
      action: "browse_impression",
      url: serverUrl + location.pathname + location.search,
      requestId: searchResults.metaData.request_id || "N.A",
      page: searchResults.metaData.category_path || "",
      page_type: "BOOLEAN",
      pids_list: (searchResults.posts || []).map(function (product) {
        return product.uniqueId;
      })
    });
  } else {
    // need to check after testing the browse search
    unbxdAnalytics({
      action: "search_impression",
      query: filters.text || "",
      url: serverUrl + location.pathname + location.search,
      requestId: searchResults.metaData.request_id || "N.A",
      pids_list: (searchResults.posts || []).map(function (product) {
        return product.uniqueId;
      })
    });
  }
}
var _useLocalStorage = useLocalStorage(),
  getLocalStorage = _useLocalStorage.getLocalStorage;
var trackSearchEvents = function trackSearchEvents(page, filters, searchResults, location) {
  var _window, _window$lastClickedFi, _window3, _window3$lastClickedF, _window4, _window4$lastClickedF, _window5, _window5$lastClickedF, _searchResults$select, _searchResults$select2, _searchResults$select3, _searchResults$select4, _searchResults$select5, _searchResults$select6, _window6, _window6$lastClickedF, _window7, _window7$lastClickedF;
  filters = handleFilter(filters);
  var isFiltersSearch = Object.keys(filters).filter(function (key) {
    return key !== "text";
  }).length > 0 || filters.text != "";
  if (!searchResults.metaData) return;
  var _useLocalStorage2 = useLocalStorage(),
    removeLocalStorage = _useLocalStorage2.removeLocalStorage;
  var hashObject = getAndClearTrackingReferralParams(false);
  var isBrowseSearch = !hashObject.hasOwnProperty("is_filter_search") && (hashObject.hasOwnProperty("referral_location") || isAutosOrYearsScreen(location));
  var isTextSearch = filters.text;
  var searchHistory = JSON.parse(getLocalStorage("searchHistory")) || [];
  var isRecentSearch = searchHistory === null || searchHistory === void 0 ? void 0 : searchHistory.some(function (history) {
    return history.text === filters.text;
  });
  if (isTextSearch) {
    var interactionType = "user input"; // Default

    if (isRecentSearch && location.search.indexOf("fromRecentSearch=1") > -1) {
      interactionType = "recent_search";
    } else if (window.searchSuggestion) {
      interactionType = "query suggest";
    }
    trackEvents("search", {
      search_query: filters.text,
      results_count: searchResults.metaData.productsCount.toString(),
      interaction_type: interactionType,
      page_number: page,
      search_pagination: page,
      referral_location: getLocalStorage("text_search_referral_location")
    });
    removeLocalStorage("text_search_referral_location");
    return;
  }
  if (isBrowseSearch && !isTextSearch) {
    var _findOptionByField, _findOptionByField$ra, _findOptionByField2, _findOptionByField3;
    removeLocalStorage("referral_location");
    var browseEvent = {
      browse_variant: hashObject.browse_variant,
      variant_value: hashObject.variant_value,
      results_count: searchResults.metaData.productsCount,
      page_number: page,
      referral_location: "autos"
    };
    var findOptionByField = function findOptionByField(field) {
      return searchResults.selectedOptions.find(function (option) {
        return option.filterField === field;
      });
    };
    var yearOption = (_findOptionByField = findOptionByField("year")) === null || _findOptionByField === void 0 ? void 0 : (_findOptionByField$ra = _findOptionByField.range_values) === null || _findOptionByField$ra === void 0 ? void 0 : _findOptionByField$ra.from;
    var modelOption = (_findOptionByField2 = findOptionByField("model_id")) === null || _findOptionByField2 === void 0 ? void 0 : _findOptionByField2.name_en;
    var makeOption = (_findOptionByField3 = findOptionByField("make_id")) === null || _findOptionByField3 === void 0 ? void 0 : _findOptionByField3.name_en;
    if (yearOption) {
      browseEvent.variant_value = yearOption;
      browseEvent.browse_variant = "year";
    } else if (modelOption) {
      browseEvent.variant_value = modelOption;
      browseEvent.browse_variant = "model";
    } else if (makeOption) {
      browseEvent.variant_value = makeOption;
      browseEvent.browse_variant = "make";
    }
    if (hashObject.referral_location) {
      browseEvent.referral_location = hashObject.referral_location;
    }
    trackEvents("browse_cars", browseEvent);
    return;
  }
  var filterValue;
  if ((_window = window) !== null && _window !== void 0 && (_window$lastClickedFi = _window.lastClickedFilter) !== null && _window$lastClickedFi !== void 0 && _window$lastClickedFi.length) {
    var _lastClickedFilter$, _window2;
    filterValue = isRangeFilter((_lastClickedFilter$ = lastClickedFilter[0]) === null || _lastClickedFilter$ === void 0 ? void 0 : _lastClickedFilter$.filterField) ? "from ".concat(window.lastClickedFilter[0].range_values.from, ", to ").concat(window.lastClickedFilter[0].range_values.to) : (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.lastClickedFilter.map(function (item) {
      return item.name_en;
    });
  }
  if (!((_window3 = window) !== null && _window3 !== void 0 && (_window3$lastClickedF = _window3.lastClickedFilter) !== null && _window3$lastClickedF !== void 0 && _window3$lastClickedF.length) && !isFiltersSearch) {
    window.lastClickedFilter = null;
    return;
  }
  Array.isArray(filterValue) && (filterValue = filterValue.join(", "));
  trackEvents("filter_search", {
    filter_name: (_window4 = window) !== null && _window4 !== void 0 && (_window4$lastClickedF = _window4.lastClickedFilter) !== null && _window4$lastClickedF !== void 0 && _window4$lastClickedF.length ? (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$lastClickedF = _window5.lastClickedFilter[0]) === null || _window5$lastClickedF === void 0 ? void 0 : _window5$lastClickedF.filterField : ((_searchResults$select = searchResults.selectedOptions) === null || _searchResults$select === void 0 ? void 0 : (_searchResults$select2 = _searchResults$select[((_searchResults$select3 = searchResults.selectedOptions) === null || _searchResults$select3 === void 0 ? void 0 : _searchResults$select3.length) - 1]) === null || _searchResults$select2 === void 0 ? void 0 : _searchResults$select2.filterField) || null,
    filter_value: filterValue ? filterValue : ((_searchResults$select4 = searchResults.selectedOptions) === null || _searchResults$select4 === void 0 ? void 0 : (_searchResults$select5 = _searchResults$select4[((_searchResults$select6 = searchResults.selectedOptions) === null || _searchResults$select6 === void 0 ? void 0 : _searchResults$select6.length) - 1]) === null || _searchResults$select5 === void 0 ? void 0 : _searchResults$select5.name_en) || null,
    results_count: searchResults.metaData.productsCount,
    page_number: page,
    referral_location: getLocalStorage("referral_location")
  });
  unbxdAnalytics({
    action: "filter_search",
    filter_name: (_window6 = window) !== null && _window6 !== void 0 && (_window6$lastClickedF = _window6.lastClickedFilter) !== null && _window6$lastClickedF !== void 0 && _window6$lastClickedF.length ? (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$lastClickedF = _window7.lastClickedFilter[0]) === null || _window7$lastClickedF === void 0 ? void 0 : _window7$lastClickedF.filterField : null,
    filter_value: filterValue ? filterValue : null,
    results_count: searchResults.metaData.productsCount,
    page_number: page,
    requestId: searchResults.metaData.request_id || "N.A",
    referral_location: getLocalStorage("referral_location")
  });
  removeLocalStorage("is_filter_search");
  window.lastClickedFilter = null;
};